import { useEffect, useState } from "react";
import "./History.css";

export default function History() {
  const [payments, setPayments] = useState([]);

  useEffect(() => {
    fetch("https://backend-ourcountryourpeople-4.onrender.com/razorpay/payments")
      .then((res) => res.json())
      .then((data) => setPayments(data))
      .catch((err) => console.error(err));
  }, []);

  return (
    <div className="payment-history">
      <h2>Payment History</h2>

      <div className="table-wrapper">
        <table>
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Amount</th>
              <th>Payment ID</th>
              <th>Date</th>
            </tr>
          </thead>

          <tbody>
            {payments.length === 0 ? (
              <tr>
                <td colSpan="5" className="no-data">
                  No payments found
                </td>
              </tr>
            ) : (
              payments.map((p) => (
                <tr key={p._id}>
                  <td>{p.name}</td>
                  <td>{p.email}</td>
                  <td>₹{p.amount}</td>
                  <td>{p.razorpay_payment_id}</td>
                  <td>{new Date(p.createdAt).toLocaleString()}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
